// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2WqFE","options":"AnswerScale_options__1HS4N","selected":"AnswerScale_selected__10KOw"};